// Analytics tracking utilities

export function trackEvent(eventName, eventData = {}) {
  // Track GA4 event
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventData);
  }

  // Track Fathom event
  if (typeof window !== 'undefined' && window.fathom) {
    window.fathom.trackEvent(eventName);
  }
}

export function trackAddToCart(product) {
  trackEvent('add_to_cart', {
    currency: 'USD',
    value: parseFloat(product.price || 0),
    items: [{
      item_id: product.id,
      item_name: product.name,
      price: parseFloat(product.price || 0),
      quantity: 1,
    }],
  });
}

export function trackCheckout(cartItems, total) {
  trackEvent('begin_checkout', {
    currency: 'USD',
    value: total,
    items: cartItems.map(item => ({
      item_id: item.id,
      item_name: item.name,
      price: parseFloat(item.price || 0),
      quantity: item.quantity,
    })),
  });
}

export function trackEmailSubmit(cartItems, total, email) {
  trackEvent('provide_checkout_email', {
    currency: 'USD',
    value: total,
    email: email,
    items: cartItems.map(item => ({
      item_id: item.id,
      item_name: item.name,
      price: parseFloat(item.price || 0),
      quantity: item.quantity,
    })),
  });
}

